import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FlexRow } from 'ui-components/components/flex';
import { Drawer } from 'ui-components/components/drawer/drawer';
import { DrawerHeader } from 'ui-components/components/drawer/drawer-header';
import { OptionCard } from './option-card';
import { TEMPLATE_OPTION_TYPE, BLANK_OPTION_TYPE } from './constants';
import messages from '../messages';
import style from './style.module.less';

/**
 * @param {object} props
 * @param {() => void} props.onClose
 * @returns {JSX.Element}
 */
export const NewShopperOptions = ({ onClose }) => {
  return (
    <Drawer canvasClassName={style['edit-shopper-canvas']} onCancel={onClose} onClose={onClose}>
      <DrawerHeader
        closeButtonAriaLabel={messages.closeNewShopperButtonAriaLabel}
        title={<FormattedMessage {...messages.newShopperDrawerHeaderText} />}
        titleClassName={style['drawer-header-title']}
      />
      <FlexRow className={style['option-card-container']}>
        <OptionCard
          buttonText={messages.startWithRecommendedButton}
          cardText={messages.startWithRecommendedInfo}
          cardTitle={messages.startWithRecommendedTitle}
          onClose={onClose}
          templateOptionType={TEMPLATE_OPTION_TYPE}
        />
        <OptionCard
          buttonText={messages.buildFromScratchButton}
          cardText={messages.buildFromScratchInfo}
          cardTitle={messages.buildFromScratchTitle}
          onClose={onClose}
          templateOptionType={BLANK_OPTION_TYPE}
        />
      </FlexRow>
    </Drawer>
  );
};
